import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import ROUTES from '../../../routes/Routes.js';

export default function CompanyTable({ companies, currentPage, itemsPerPage, handleSort, sortField, sortOrder, onDelete }) {
    return (
        <>
            <table className="table">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th onClick={() => handleSort('name')} style={{ cursor: 'pointer', textDecoration: "underline" }}>Nombre{' '}
                            {sortField === 'name' && (
                                sortOrder === 'asc'
                                    ? <i className="bi bi-caret-up-fill"></i>
                                    : <i className="bi bi-caret-down-fill"></i>
                            )}
                        </th>
                        <th onClick={() => handleSort('shortname')} style={{ cursor: 'pointer', textDecoration: "underline" }}>Nombre corto{' '}
                            {sortField === 'shortname' && (
                                sortOrder === 'asc'
                                    ? <i className="bi bi-caret-up-fill"></i>
                                    : <i className="bi bi-caret-down-fill"></i>
                            )}
                        </th>
                        <th scope="col">Fecha de creación</th>                            
                        <th scope="col">Comentarios</th>
                        <th scope="col">Acciones</th>
                    </tr>
                </thead>
                <tbody className="table-group-divider">
                    {companies?.length === 0 ? (
                        <tr>
                            <td colSpan="6" className="text-center">
                                No hay registros disponibles
                            </td>
                        </tr>
                    ) : (
                        companies.map((company, index) => {
                            const rowNumber = (currentPage - 1) * itemsPerPage + index + 1;
                            return (
                                <tr key={company.id}>
                                    <td>{rowNumber}</td>
                                    <td>{company.name}</td>
                                    <td>{company.shortname}</td>
                                    <td>{format(new Date(company.createdAt), 'dd-MM-yyyy')}</td>
                                    <td>{company.description}</td>
                                    <td>    
                                        <Link to={`${ROUTES.EDIT_COMPANY}/${company.id}`} className="btn btn-primary me-md-2"><i className="bi bi-pencil-square"></i></Link>                                        
                                        <button onClick={() => onDelete(company)} disabled={company.id === 1} className="btn btn-danger"><i className="bi bi-trash3-fill"></i></button>
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </table>
        </>
    );
}